// extracted by mini-css-extract-plugin
export default {"archiveDashboardWrapper":"Archive_archiveDashboardWrapper__HNJuJ","modalContent":"Archive_modalContent__ud6bh"};